import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import Add from "./Add";
import Edit from "./Edit";
import Externals from "./Externals";

function ExternalRoutes(): JSX.Element {
    return (
        <Routes>
            <Route path="add" element={<Add />} />
            <Route path=":externalId/edit" element={<Edit />} />
            <Route index element={<Externals />} />
        </Routes>
    );
}

export default ExternalRoutes;
